/* global $, document */
// Third party
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import { createStore } from 'redux'
    
import 'jquery';
import 'bootstrapcss';
import '../node_modules/react-grid-layout/css/styles.css';
import '../node_modules/react-resizable/css/styles.css';
import '../node_modules/react-bootstrap-table/css/react-bootstrap-table.css';
import './myStyle.css';
import netVizApp from './reducers/reducers';
import {AppContainer} from './App';


/*
    Instead of this line to create the store:
let store = createStore(netVizApp);

    I'm using the following to enable Redux chrome tools
 */
export default function configureStore(initialState) {
  const store = createStore(netVizApp, initialState,
    window.devToolsExtension ? window.devToolsExtension() : undefined
  );
  return store;
}



ReactDOM.render(
    <Provider store={configureStore()}>
        <AppContainer />
        </Provider>
        , document.getElementById('PageContent'));





// WEBPACK FOOTER //
// ./src/main.js